export const DepositFilterTypes = {
  ALL_DEPOSITS: 'all_deposits',
  CONFIRMED_DEPOSITS: 'confirmed_deposits',
  PENDING_DEPOSITS: 'pending_deposits',
};



// WEBPACK FOOTER //
// ./src/utils/constants/deposits.js